export default "__VITE_ASSET__Cx96$zbw__"